<!-- <div class="flex" *ngIf="this._authService.instance.getAllAccounts().length === 0">
            <div class="flex-1 flex align-items-center justify-content-center font-bold text-gray-900 m-2 px-5 py-3 border-round">{{displayText}}</div>
        </div> -->
<div *ngIf="this._authService.instance.getAllAccounts().length > 0 && this._commonService.hasAdminAccess && this._commonService.hasCommonAccess">
    <p-carousel [value]="products" [numVisible]="3" [numScroll]="1" [circular]="true" [autoplayInterval]="3000"
        [responsiveOptions]="responsiveOptions" [showNavigators]="false">
        <ng-template let-product pTemplate="item">
            <div class="product-item">
                <div class="product-item-content">
                    <div class="mb-3">
                        <img src="assets/images/{{product.image}}" [alt]="product.name" class="product-image" />
                    </div>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>

<div class="grid" *ngIf="this._authService.instance.getAllAccounts().length === 0">
    <div class="col-12 md:col-6 lg:col-12 flex align-items-center justify-content-center">
        <h2 class="mb-0 mt-0">Welcome!!!</h2>
    </div>
    <div class="col-12 md:col-6 lg:col-12 flex align-items-center justify-content-center">
        <span class="font-italic">External Transaction Administration Portal</span>
    </div>
    <div class="col-12 md:col-2 lg:col-2"></div>
    <div class="col-12 md:col-4 lg:col-4 flex align-items-center justify-content-center">
        <img src="assets/images/TerraStar_CorrectionServicesAd.png"/>
    </div>            
    <div class="col-12 md:col-4 lg:col-4 flex align-items-center justify-content-center">
        <img src="assets/images/info.png"/>
    </div>
</div>

<div class="grid" *ngIf="!this._commonService.hasAdminAccess && !this._commonService.hasCommonAccess">
    <div class="col-12 md:col-6 lg:col-12 flex align-items-center justify-content-center">
        <h2 class="mb-0 mt-0">{{text}}</h2>
    </div>
</div>
  



